import React from "react";

// import { LifeLine } from "react-loading-indicators";

import { useCancelCallModal } from "../hooks/useCancelCallModal";

import CancelCallModal from "./modals/CancelCallModal";

import AnimatedEllipsis from "./AnimatedEllipsis";

import { useTranslation } from "react-i18next";

interface WaitingCallProps {
  showLogo: boolean;
  logo?: string;
  loading?: string;
  recipientImage?: string;
  recipientName?: string;
  recipientSpecialty?: string;
  transactionStatus?: number;
  isCancelDisabled?: boolean;
  handleCancelCallConfirm: () => Promise<void>;
  isTytoModalOpened: boolean;
  isConsentModalOpened: boolean;
  isMTLBenefitModalOpened: boolean;
}

export default function WaitingCall({
  showLogo,
  logo,
  loading,
  recipientImage,
  recipientName,
  recipientSpecialty,
  transactionStatus,
  isCancelDisabled,
  handleCancelCallConfirm,
  isTytoModalOpened,
  isConsentModalOpened,
  isMTLBenefitModalOpened,
}: WaitingCallProps) {
  const {
    isVisible,
    showCancelCallModal,
    hideCancelCallModal,
    // handleCancelCallConfirm,
    // handleBack,
  } = useCancelCallModal({
    handleCancelCallConfirm,
    isTytoModalOpened,
    isConsentModalOpened,
    isMTLBenefitModalOpened,
  });

  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-y-4 w-full">
      <div className="max-w-3xl border p-10 rounded-3xl shadow-md bg-white items-center flex flex-col">
        {/* Partner / Hospital Logo */}
        <div className="flex flex-col gap-y-1 items-center mb-4">
          {showLogo && logo && (
            <img
              src={logo}
              width={172}
              height={40}
              className="max-h-16 mb-10"
              alt="logo"
            />
          )}
        </div>

        {/* Title */}
        <div className="mb-4 w-full text-center">
          {recipientName ? (
            <AnimatedEllipsis text={t("pages.waitingCall.text.title")} />
          ) : (
            <span className="text-center">{t("pages.waitingCall.text.title")}</span>
          )}
        </div>

        {/* Loading Animation */}
        {
          loading && !recipientName && (
            <img
              src={loading}
              alt="loading"
              className="w-32 h-32 object-contain"
            />
          )
          // : (
          //   <LifeLine color="#12663F" size="medium" text="" textColor="" />
          // )
        }

        {/* Recipient Info */}
        {recipientName && (
          <div className="flex flex-col items-center mt-6">
            {recipientImage && (
              <img
                src={recipientImage}
                alt="recipient"
                className="w-[200px] h-[200px] rounded-full mb-4 object-cover object-center"
              />
            )}
            <p className="font-medium">{recipientName}</p>
            {recipientSpecialty && (
              <p className="text-sm text-gray-500">{recipientSpecialty}</p>
            )}
          </div>
        )}

        {/* Buttons */}
        <div className="flex flex-col items-center sm:flex-row sm:gap-x-2">
          {/* <button
            onClick={handleBack}
            className="px-4 py-2 rounded-3xl text-svvh-green bg-white border border-svvh-green hover:bg-svvh-light-green w-[120px] mt-4"
          >
            {t("pages.waitingCall.buttons.back")}
          </button> */}
          {!isCancelDisabled && (
            <button
              onClick={showCancelCallModal}
              disabled={isCancelDisabled}
              // className={`px-4 py-2 rounded-3xl text-white w-[260px] mt-4 ${
              //   isCancelDisabled
              //     ? "bg-gray-400 cursor-not-allowed"
              //     : "bg-svvh-green hover:bg-green-700"
              // }`}
              className={`px-6 py-3 rounded-3xl font-medium w-[260px] mt-4 transition-all duration-300 ${
                isCancelDisabled
                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                  : "bg-gray-50 text-gray-600 border border-gray-300 hover:bg-gray-100 hover:border-gray-400 hover:text-gray-700 active:bg-gray-200"
              }`}
            >
              {t("pages.waitingCall.buttons.cancelCall")}
            </button>
          )}
        </div>

        {/* Notes */}
        <div className="flex flex-col text-center text-gray-400 text-sm mt-8">
          <p>{t("pages.waitingCall.text.noted1")}</p>
          <p>{t("pages.waitingCall.text.noted2")}</p>
        </div>
      </div>

      {/* Cancel Call Modal */}
      {!isCancelDisabled && (
        <CancelCallModal
          isVisible={isVisible}
          onConfirm={handleCancelCallConfirm}
          onClose={hideCancelCallModal}
          translate={t}
        />
      )}
    </div>
  );
}
